<template>
  <transition name="fade">
    <div v-if="show" class="concept-root">
      <div class="bgs">
        <div :style="bg1Style" class="bg bg1">
          <blur-image
            width="510"
            height="340"
            url="/images/bg/bg1.jpg"
            :px="blurPixel"
          ></blur-image>
        </div>
        <div :style="bg2Style" class="bg bg2"></div>
      </div>

      <div class="texts">
        <div class="text text1">
          <span :style="text1Part1Style" class="part part1">
            <blur-image
              width="36"
              height="140"
              url="/images/concept/text1-1@2x.png"
              :px="blurPixel"
            ></blur-image>
          </span>
          <span :style="text1Part2Style" class="part part2">
            <blur-image
              width="36"
              height="170"
              url="/images/concept/text1-2@2x.png"
            ></blur-image>
          </span>
          <br />
          <span :style="text1Part2Style" class="part part3">
            <blur-image
              width="36"
              height="170"
              url="/images/concept/text1-3@2x.png"
            ></blur-image>
          </span>
          <span :style="text1Part4Style" class="part part4">
            <blur-image
              width="36"
              height="170"
              url="/images/concept/text1-4@2x.png"
            ></blur-image>
          </span>
          <br />
          <span :style="text1Part5Style" class="part part5">
            <blur-image
              width="36"
              height="170"
              url="/images/concept/text1-5@2x.png"
              :px="blurPixel"
            ></blur-image>
          </span>
        </div>

        <div class="text text2">
          <div :style="text2Part1Style" class="part1">Nihon Ga Suki.</div>
          <div :style="text2Part2Style" class="part2">
            Dakara, Tsunaide, Shiawase ni.
          </div>
        </div>

        <div class="text text3">
          <div :style="text3Part1Style" class="part part1">
            <blur-image
              width="309"
              height="81"
              url="/images/concept/text2-1@2x.png"
            ></blur-image>
          </div>

          <div :style="text3Part2Style" class="part part2">
            <blur-image
              width="376"
              height="137"
              url="/images/concept/text2-2@2x.png"
              :px="blurPixel"
            ></blur-image>
          </div>

          <div :style="text3Part3Style" class="part part3">
            <blur-image
              width="305"
              height="81"
              url="/images/concept/text2-3@2x.png"
              :px="blurPixel"
            ></blur-image>
          </div>

          <div :style="text3Part4Style" class="part part4">
            <blur-image
              width="269"
              height="81"
              url="/images/concept/text2-4@2x.png"
              :px="blurPixel"
            ></blur-image>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { fadeStyle, transformStyle, blurPixel } from '../../lib/styleGenerator'

export default {
  name: 'pageConcept',

  computed: {
    blurPixel() {
      return blurPixel(this.scrollRate)
    },
    show() {
      const currentPage = this.$store.getters.currentPage

      return currentPage === 'concept'
    },
    scrollRate() {
      return this.$store.getters.conceptPageRate
    },
    text1Part1Style() {
      return {
        ...fadeStyle(this.scrollRate),
        ...transformStyle(this.scrollRate, { scale: 1.5, y: 10 })
      }
    },
    text1Part2Style() {
      return {
        ...transformStyle(this.scrollRate, { y: 50 })
      }
    },
    text1Part4Style() {
      return {
        ...transformStyle(this.scrollRate, { y: 100 })
      }
    },
    text1Part5Style() {
      return {
        ...transformStyle(this.scrollRate, { y: 100, scale: 1.5 }),
        ...fadeStyle(this.scrollRate)
      }
    },
    text2Part1Style() {
      return {
        ...transformStyle(this.scrollRate, { x: 20 })
      }
    },
    text2Part2Style() {
      return {
        ...transformStyle(this.scrollRate, { x: 50 })
      }
    },
    text3Part1Style() {
      return {
        ...transformStyle(this.scrollRate, { y: 100 })
      }
    },
    text3Part2Style() {
      return {
        ...transformStyle(this.scrollRate, { x: -50, y: -50, scale: 1.2 }),
        ...fadeStyle(this.scrollRate)
      }
    },
    text3Part3Style() {
      return {
        ...transformStyle(this.scrollRate, { x: -10, y: 50 }),
        ...fadeStyle(this.scrollRate)
      }
    },
    text3Part4Style() {
      return {
        ...transformStyle(this.scrollRate, { y: 100 })
      }
    },
    bg1Style() {
      return {
        ...transformStyle(this.scrollRate, { y: 50 }),
        ...fadeStyle(this.scrollRate)
      }
    },
    bg2Style() {
      return {
        ...transformStyle(this.scrollRate, { x: -100 })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.concept-root
  position: relative

.text
  background-repeat: no-repeat
  position: absolute

.text1
  width: 200px
  height: 400px
  top: 70px
  left: 280px
  font-size: 37px
  letter-spacing: 7px
  line-height: 65px
  font-weight: bold

  .part
    display: block
    position: absolute

  .part1, .part2
    position: absolute
    top: 0
    right: 0

  .part2
    top: 140px

  .part3
    top: 0
    right: 60px

  .part4
    top: 170px
    right: 60px

  .part5
    top: 0
    right: 120px

.text2
  width: auto
  height: 50px
  top: 130px
  left: 500px
  font-size: 12px
  font-weight: bold

.text3
  width: 340px
  height: 500px
  top: 136px
  right: 150px
  font-size: 13px
  line-height: 26px
  font-weight: bold

  .part
    margin-bottom: 20px

.bg
  position: absolute
  background-size: cover
  width: 510px
  height: 340px
  &1
    left: 380px
    top: 270px
  &2
    left: -50px
    top: 200px
    background-image: url('/images/bg/bg2.jpg')
  &3
    opacity: 0.3
    filter: blur(3px)
    right: 130px
    top: 380px
    background-image: url('/images/bg/bg3.jpg')
  &4
    opacity: 0.3
    filter: blur(3px)
    right: 222px
    top: 177px
    background-image: url('/images/bg/bg4.jpg')
</style>
